@let cols = columns();
@let fil = filters();

<div class="flex min-w-0 flex-1 flex-col">
  <ng-content select="[before-table]"></ng-content>

  <div class="flex-1 p-6">
    <aura-data-table
      matSort
      [searchPlaceHolder]="'Rechercher par numéro, SIREN, raison sociale, CCI...'"
      [inputColumns]="cols"
      [filters]="fil"
      [items]="items()"
      [count]="count()"
      [loading]="isLoading()"
      [pagination]="pagination()"
      [topButtons]="topButtons()"
      [itemActions]="itemActions()"
      [mappedFilters]="mappedFilters()"
      [rowClickable]="rowClickable()"
      (removeFilter)="removeFilter()?.($event)"
      (clearFiltering)="clearFiltering()?.()"
      (triggerRefresh)="triggerRefresh()?.()"
      (triggerFiltering)="triggerFiltering()?.()"
      (filterViewChanged)="filterViewChanged()?.($event)"
      (itemClicked)="itemClicked()?.($event)"
      (pageChanged)="pageChanged()?.($event)"
      (searchChanged)="searchChanged()?.($event)"
      (matSortChange)="sortChanged()?.($event)"
    >
      <ng-template #filterTemplate>
        <etxe-agent-cards-data-table-filter
          [dto]="appliedFilter()"
          [filters]="fil"
          [currentFilterView]="currentFilterView()"
          (filterChanged)="filterChanged()?.($event)"
        />
      </ng-template>

      @for (column of cols; track $index) {
        @if (!column.native) {
          <ng-container [matColumnDef]="column.key">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [sortActionDescription]="'Trier par ' + column.label | lowercase"
              class="font-bold! text-indigo-11!"
            >
              {{ column.label }}
            </th>
            @switch (column.key) {
              @case ('number') {
                <td mat-cell *matCellDef="let card" class="py-4">
                  <div class="flex items-center gap-2">
                    <span
                      class="font-mono font-semibold text-xs px-2.5 py-1 rounded-md bg-primary-2 text-primary-11 border border-primary-4"
                    >
                      {{ card.number || '-' }}
                    </span>
                  </div>
                </td>
              }
              @case ('companyName') {
                <td mat-cell *matCellDef="let card" class="py-4">
                  <div class="flex flex-col min-w-0">
                    <span class="font-semibold text-gray-12 truncate max-w-xs" [title]="card.companyName">
                      {{ card.companyName || '-' }}
                    </span>
                    @if (card.legalForm) {
                      <span class="text-xs text-gray-9 truncate">
                        {{ card.legalForm }}
                      </span>
                    }
                  </div>
                </td>
              }
              @case ('siren') {
                <td mat-cell *matCellDef="let card" class="py-4">
                  <span class="font-mono text-xs text-gray-12 font-medium">
                    {{ card.siren || '-' }}
                  </span>
                </td>
              }
              @case ('leader') {
                <td mat-cell *matCellDef="let card" class="py-4">
                  @if (card.leader; as leader) {
                    <div class="flex items-center gap-2">
                      <span class="font-medium text-gray-12 text-sm">
                        {{ leader.firstName | titlecase }} {{ leader.lastName | titlecase }}
                      </span>
                    </div>
                  } @else {
                    <span class="italic text-xs text-gray-9">-</span>
                  }
                </td>
              }
              @case ('cci') {
                <td mat-cell *matCellDef="let card" class="py-4">
                  @if (card.cci?.name; as cciName) {
                    <div class="flex flex-col min-w-0 max-w-xs">
                      <span class="font-medium text-gray-12 text-sm truncate" [title]="cciName">
                        {{ cciName }}
                      </span>
                      @if (card.cci?.president; as pres) {
                        <span
                          class="text-xs text-gray-9 truncate"
                          [title]="
                            'Président : ' + (pres.firstName | titlecase) + ' ' + (pres.lastName | titlecase)
                          "
                        >
                          {{ pres.firstName | titlecase }} {{ pres.lastName | titlecase }}
                        </span>
                      }
                    </div>
                  } @else {
                    <span class="italic text-xs text-gray-9">-</span>
                  }
                </td>
              }
              @case ('departmentCode') {
                <td mat-cell *matCellDef="let card" class="py-4">
                  @if (card.address?.departmentCode; as dept) {
                    <span
                      class="inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold bg-gray-3 text-gray-12 border border-gray-5 cursor-default"
                      [matTooltip]="getDepartmentName(dept)"
                    >
                      {{ dept }}
                    </span>
                  } @else {
                    <span class="italic text-xs text-gray-9">-</span>
                  }
                </td>
              }
              @case ('mentions') {
                <td mat-cell *matCellDef="let card" class="py-4">
                  <div class="flex flex-wrap items-center gap-1.5 max-w-xs">
                    @if (card.mentions?.transaction) {
                      <span
                        class="px-2 py-0.5 rounded-full text-[11px] font-medium bg-jade-2 text-jade-11 border border-jade-5"
                      >
                        Transaction
                      </span>
                    }
                    @if (card.mentions?.management) {
                      <span
                        class="px-2 py-0.5 rounded-full text-[11px] font-medium bg-blue-2 text-blue-11 border border-blue-5"
                      >
                        Gestion
                      </span>
                    }
                    @if (card.mentions?.syndic) {
                      <span
                        class="px-2 py-0.5 rounded-full text-[11px] font-medium bg-amber-2 text-amber-11 border border-amber-5"
                      >
                        Syndic
                      </span>
                    }
                    @if (card.mentions?.listBroker) {
                      <span
                        class="px-2 py-0.5 rounded-full text-[11px] font-medium bg-purple-2 text-purple-11 border border-purple-5"
                      >
                        Marchand de listes
                      </span>
                    }
                    @if (card.mentions?.tourism) {
                      <span
                        class="px-2 py-0.5 rounded-full text-[11px] font-medium bg-pink-2 text-pink-11 border border-pink-5"
                      >
                        Tourisme
                      </span>
                    }
                    @if (card.mentions?.service) {
                      <span
                        class="px-2 py-0.5 rounded-full text-[11px] font-medium bg-gray-2 text-gray-11 border border-gray-5"
                      >
                        Services
                      </span>
                    }
                  </div>
                </td>
              }
              @case ('expiresAt') {
                <td mat-cell *matCellDef="let card" class="py-4">
                  @if (card.expiresAt) {
                    <div class="flex items-center gap-2">
                      <span
                        class="text-xs font-medium"
                        [class.text-ruby-11]="isCardExpired(card.expiresAt)"
                        [class.text-gray-12]="!isCardExpired(card.expiresAt)"
                      >
                        {{ card.expiresAt | date: 'dd/MM/yyyy' }}
                      </span>
                      @if (isCardExpired(card.expiresAt)) {
                        <span
                          class="px-1.5 py-0.5 text-[10px] font-bold rounded bg-ruby-2 text-ruby-11 border border-ruby-5"
                        >
                          Expirée
                        </span>
                      }
                    </div>
                  } @else {
                    <span class="italic text-xs text-gray-9">-</span>
                  }
                </td>
              }
              @default {
                <td mat-cell *matCellDef="let card">{{ card[column.key] }}</td>
              }
            }
          </ng-container>
        }
      }
    </aura-data-table>
  </div>
</div>
